import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    cont: {},
}));

const localizer = momentLocalizer(moment);

const PtoCalendar = ({
    getCalendarDates,
    handleOpen,
    getDialogObj,
    events,
}) => {
    const handleSelect = e => {
        getCalendarDates(e.start, e.end);
        return;
    };

    const handleOpenEvent = e => {
        getDialogObj(e);
        handleOpen(e);
        return;
    };

    const getEventColor = event => {
        let newStyle = {
            backgroundColor: "",
            color: "white",
        };
        if (event.requestStatus === "Pending") {
            newStyle.backgroundColor = "#FDD835";
            newStyle.color = "black";
        }
        if (event.requestStatus === "Approved") {
            newStyle.backgroundColor = "#1B5E20";
        }
        if (event.requestStatus === "Declined") {
            newStyle.backgroundColor = "#DD2C00";
        }

        return {
            className: "",
            style: newStyle,
        };
    };

    return (
        <Calendar
            localizer={localizer}
            selectable={true}
            views={["day", "week", "month"]}
            defaultView="month"
            events={events}
            startAccessor="start"
            endAccessor="end"
            titleAccessor="requestTitle"
            onSelectEvent={e => handleOpenEvent(e)}
            onSelectSlot={handleSelect}
            style={{
                height: "70vh",
                width: "70vw",
            }}
            eventPropGetter={e => getEventColor(e)}
        />
    );
};

export default PtoCalendar;
